import client from '../../../config/api';

import {
  LOCAL_SET_INSTRUMENTATIONS,
  LOCAL_ADD_INSTRUMENTATION,
  LOCAL_DELETE_INSTRUMENTATION,
  LOCAL_UPDATE_INSTRUMENTATION,
  LOCAL_SET_INSTRUMENTATIONS_TASK,
  LOCAL_SET_INSTRUMENTATION_HISTORY,
  LOCAL_SET_INSTRUMENTATION_JOB_HISTORY,
  LOCAL_SET_COUNT_BY_SITE_ID,
} from '../mutations/mutationTypes';

export default {
  async FETCH_INSTRUMENTATIONS({ commit }, { siteId, query }) {
    const result = await client.get(`/instrumentations/site/${siteId}`, {
      params: {
        ...query,
      },
    });

    if (result.data.items) {
      commit(LOCAL_SET_INSTRUMENTATIONS, result.data.items);
      commit(LOCAL_SET_COUNT_BY_SITE_ID, result.data.countsBySiteId);
    } else {
      commit(LOCAL_SET_INSTRUMENTATIONS, result?.data || []);
      commit(LOCAL_SET_COUNT_BY_SITE_ID, {});
    }
  },

  async ADD_INSTRUMENTATION({ commit }, { siteId, instrumentationData }) {
    try {
      await client.post(
        `/instrumentations/site/${siteId}`,
        instrumentationData
      );
      commit(LOCAL_ADD_INSTRUMENTATION, instrumentationData);
    } catch (error) {
      if (error.data && error.data.duplicate) {
        throw error;
      }
    }
  },

  async DELETE_INSTRUMENTATION({ commit }, { instrumentationId }) {
    await client.delete(`/instrumentations/${instrumentationId}`);
    commit(LOCAL_DELETE_INSTRUMENTATION, instrumentationId);
  },

  async UPDATE_INSTRUMENTATION(
    { commit },
    { instrumentationId, instrumentationData }
  ) {
    await client.put(
      `/instrumentations/${instrumentationId}`,
      instrumentationData
    );

    commit(LOCAL_UPDATE_INSTRUMENTATION, {
      instrumentationId,
      instrumentationData,
    });
  },

  async LINK_INSTRUMENTATION_TASK(_, { instrumentations, taskId }) {
    await client.post(`/instrumentations/task/${taskId}`, { instrumentations });
  },

  async FETCH_INSTRUMENTATION_TASKS({ commit }, { taskId }) {
    const result = await client.get(`/instrumentations/task/${taskId}`);
    commit(LOCAL_SET_INSTRUMENTATIONS_TASK, result?.data || []);
  },

  async FETCH_INSTRUMENTATION_HISTORY({ commit }, { instrumentationId }) {
    const result = await client.get(
      `/instrumentations/history/${instrumentationId}`
    );
    commit(LOCAL_SET_INSTRUMENTATION_HISTORY, result?.data || []);
  },

  async FETCH_INSTRUMENTATION_JOB_HISTORY({ commit }, { jobId }) {
    const result = await client.get(`/instrumentations/history/job/${jobId}`);
    commit(LOCAL_SET_INSTRUMENTATION_JOB_HISTORY, result?.data || []);
  },
};
